import React from 'react';
import { Typography, Stack, Tooltip } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectAttendanceMode } from '../redux/slices/authSlice';
import { attendanceModeOf } from '../data/attendanceModes';

/**
 * The signed-in user's attendance mode, as it arrives on the login response.
 * Says which punch channels count for them — see data/attendanceModes.js.
 *
 * variant "solid"  — tinted pill for light surfaces (default)
 * variant "onDark" — translucent pill for the gradient account header
 */
export default function AttendanceModeBadge({ variant = 'solid', showSub = false, sx }) {
    const mode = useSelector(selectAttendanceMode);
    const m = attendanceModeOf(mode);
    const onDark = variant === 'onDark';

    return (
        <Tooltip arrow title={m.description}>
            <Stack
                direction="row"
                spacing={0.6}
                sx={{
                    alignItems: 'center', height: 22, px: 0.9, borderRadius: '6px',
                    flexShrink: 0, cursor: 'default', maxWidth: '100%',
                    bgcolor: onDark ? 'rgba(255,255,255,0.2)' : m.bg,
                    border: onDark ? 'none' : `1px solid ${m.border}`,
                    ...sx,
                }}
            >
                <m.icon sx={{ fontSize: 13, color: onDark ? '#fff' : m.color, flexShrink: 0 }} />
                <Typography
                    sx={{
                        fontSize: 10.5, fontWeight: 800, letterSpacing: 0.3, whiteSpace: 'nowrap',
                        color: onDark ? '#fff' : m.color,
                        textTransform: onDark ? 'uppercase' : 'none',
                    }}
                >
                    {showSub ? `${m.label} · ${m.short}` : m.label}
                </Typography>
            </Stack>
        </Tooltip>
    );
}
